import { Link, Paragraph } from '@vimeo/iris/typography';

export default function Stock() {
  return (
    <div>
      <Paragraph size="2">
        <em>Vimeo Stock</em> is a marketplace for royalty-free stock video. For more information,
        see our{' '}
        <Link
          variant="minimal"
          href="https://help.vimeo.com/hc/en-us/articles/12426490430353-Browse-and-manage-Vimeo-Stock"
        >
          Help Center
        </Link>
        .
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
